import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table/columns";
import selectColumnFactory from "@/react/components/table/components/selectColumnFactory";
import { getColumnDef } from "@/react/schema/schemaFields";
import schema from "./schema";
import * as yup from "yup";
import {
  RING_BACK_MUSIC_CONTINUITY_OPTIONS,
  RING_GROUP_CALLER_ID_OPTIONS,
  RING_GROUPS,
  RING_PATTERNS,
} from "@/react/features/smp/constants";
import DidNumberSelect from "@/react/features/smp/cells/DidNumberSelect";
import BranchNameSelect from "@/react/features/smp/cells/BranchNameSelect";
import rgcqMemberColumnsGenerator from "@/react/features/smp/rgcqMemberColumnsGenerator";

const columnDefinition = () =>
  calculateColumnWidth(
    [
      selectColumnFactory(),
      {
        ...getColumnDef(schema.fields.subscriptionId, "Subscription ID"),
        type: TYPES.ID,
      },
      {
        ...getColumnDef(schema.fields.name, "Name"),
        type: TYPES.STRING,
        customCell: ({ getValue }) => <strong>{getValue()}</strong>,
        editable: true,
        sticky: true,
      },
      {
        ...getColumnDef(schema.fields.extensionNumber, "Extension"),
        editable: true,
      },
      {
        ...getColumnDef(schema.fields.branchName, "Branch Name"),
        editable: true,
        editableCell: BranchNameSelect,
      },
      {
        ...getColumnDef(schema.fields.primaryDidNumber, "Primary Phone Number"),
        editable: true,
        editableCell: DidNumberSelect,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.numOfCycles"),
          "Num of Cycles"
        ),
        editable: true,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.ringPattern"),
          "Ring Pattern"
        ),
        editable: true,
        type: TYPES.SELECT,
        options: RING_PATTERNS,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.callerIdOption"),
          "Caller ID Option"
        ),
        editable: true,
        type: TYPES.SELECT,
        options: RING_GROUP_CALLER_ID_OPTIONS,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.ringBackMusicContinuity"),
          "Ring Back Music Continuity"
        ),
        editable: true,
        type: TYPES.SELECT,
        options: RING_BACK_MUSIC_CONTINUITY_OPTIONS,
      },
      {
        ...getColumnDef(
          yup.reach(schema, "details.callWaitingDisabled"),
          "Call Waiting Disabled"
        ),
        editable: true,
        type: TYPES.BOOLEAN,
      },
      {
        ...getColumnDef(yup.reach(schema, "details.ringTimer"), "Ring Timer"),
        editable: true,
      },
      ...rgcqMemberColumnsGenerator(schema, RING_GROUPS),
    ].map(mapColumnTypes)
  );

export default columnDefinition;
